// Small line-style nav icons, one per TopBar tab - deliberately minimal (single stroke weight,
// no fills, 20x20) so they read as a quiet prefix to the label, not competing artwork.
const common = {
  width: 20,
  height: 20,
  viewBox: '0 0 20 20',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

export function BuyIcon(props) {
  return (
    <svg {...common} {...props}>
      <circle cx="10" cy="10" r="7.25" />
      <path d="M12.4 7.6c-.35-.7-1.15-1.15-2.15-1.15-1.3 0-2.35.75-2.35 1.85s1.05 1.55 2.35 1.7c1.3.15 2.35.6 2.35 1.7s-1.05 1.85-2.35 1.85c-1 0-1.8-.45-2.15-1.15M10 5.4v1.05M10 13.55v1.05" />
    </svg>
  )
}

export function EarnIcon(props) {
  return (
    <svg {...common} {...props}>
      <path d="M3.5 13.5l4-4.2 3 2.6 5.5-6" />
      <path d="M12.5 5.9h3.5v3.5" />
    </svg>
  )
}

export function BorrowIcon(props) {
  return (
    <svg {...common} {...props}>
      <path d="M10 3.5l6.5 3.35H3.5L10 3.5z" />
      <path d="M4.5 8.4v5.4M8.2 8.4v5.4M11.8 8.4v5.4M15.5 8.4v5.4" />
      <path d="M3 16.5h14" />
    </svg>
  )
}

export function MultiplyIcon(props) {
  return (
    <svg {...common} {...props}>
      <path d="M3.5 15.5l4-4 3 3 6-6.5" />
      <path d="M12.5 8h4.5v4.5" />
      <path d="M3.5 4.5v12h13" />
    </svg>
  )
}

export function FarmIcon(props) {
  return (
    <svg {...common} {...props}>
      <path d="M10 16.5V10" />
      <path d="M10 10C10 6.8 7.6 4.5 4.3 4.5 4.3 7.9 6.7 10 10 10z" />
      <path d="M10 11.8c0-2.6 2-4.6 4.7-4.6 0 2.6-2.1 4.6-4.7 4.6z" />
    </svg>
  )
}

export function StakeIcon(props) {
  return (
    <svg {...common} {...props}>
      <rect x="4" y="12.3" width="12" height="3.2" rx="0.6" />
      <rect x="4" y="8.4" width="12" height="3.2" rx="0.6" />
      <rect x="4" y="4.5" width="12" height="3.2" rx="0.6" />
    </svg>
  )
}

export function DaoIcon(props) {
  return (
    <svg {...common} {...props}>
      <path d="M3.3 7.2L10 3.5l6.7 3.7" />
      <path d="M3.3 7.2h13.4" />
      <path d="M5 7.2v7.1M9 7.2v7.1M11 7.2v7.1M15 7.2v7.1" />
      <path d="M3.3 16.5h13.4" />
    </svg>
  )
}

// Buyback: two arrows cycling round, for "revenue repurchases HORIZON on a loop".
export function BuybackIcon(props) {
  return (
    <svg {...common} {...props}>
      <path d="M4.6 8.2A6 6 0 0 1 15.4 6.9" />
      <path d="M15.4 8.4l1.1-2.1-2.3-.5" />
      <path d="M15.4 11.8A6 6 0 0 1 4.6 13.1" />
      <path d="M4.6 11.6l-1.1 2.1 2.3.5" />
    </svg>
  )
}

export function PortfolioIcon(props) {
  return (
    <svg {...common} {...props}>
      <rect x="3.2" y="6.8" width="13.6" height="8.7" rx="1.4" />
      <path d="M7.3 6.8V5.6a1.4 1.4 0 011.4-1.4h2.6a1.4 1.4 0 011.4 1.4v1.2" />
      <path d="M3.2 10.4h13.6" />
    </svg>
  )
}

export function LeaderboardIcon(props) {
  return (
    <svg {...common} {...props}>
      <path d="M6.3 16.5v-6.2M10 16.5V3.5M13.7 16.5v-9" />
    </svg>
  )
}

export function VaultsIcon(props) {
  return (
    <svg {...common} {...props}>
      <rect x="3.5" y="4" width="13" height="12" rx="1.6" />
      <circle cx="10" cy="10" r="2.4" />
      <path d="M10 7.6v.6M10 11.8v.6" />
    </svg>
  )
}
